import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, loading, isUser, isAdmin } = useAuth();
  const normalizedRequiredRole = requiredRole === 'student'
    ? 'user'
    : requiredRole === 'teacher'
      ? 'admin'
      : requiredRole;

  if (loading) {
    return <div className="loading loading-screen">Loading your workspace...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to={normalizedRequiredRole === 'admin' ? '/admin/login' : '/login'} replace />;
  }

  if (normalizedRequiredRole === 'admin' && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (normalizedRequiredRole === 'user' && !isUser) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
